// extracted by mini-css-extract-plugin
export default {"actionWrappers":"RoleFilterTabs_actionWrappers__2-z_Z","alignRight":"RoleFilterTabs_alignRight__2cluk"};